import { Objectif } from './../objectif/objectif.type';
/* eslint-disable react-hooks/exhaustive-deps */
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import {
    addDoc,
    collection,
    deleteDoc,
    doc,
    getDoc,
    getDocs,
    onSnapshot,
    orderBy,
    query,
    serverTimestamp,
    updateDoc,
    where,
    Timestamp,
    limit,
} from "firebase/firestore";
import { auth, db } from "../../../firebase";
import { Evaluation , ClassStats , DashboardStats ,StudentGroup} from "./evaluation.type";
// import { create } from "domain";
// import { update } from "firebase/database";
import { useLocationState } from "../../Utils";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Class } from "../classe/classe.type";
import { ObjectifStudent } from "../objectifStudent/objectifStudent.type";
import { Bulletin } from "../bulletin/bulletin.type";
import { Absence } from "../absence/absence.type";


export const EvaluationApi = createApi({
    reducerPath: "evaluationApi",
    tagTypes: ["evaluation", "evaluations", "evaluationsByStudent", "evaluationsByProf", "evaluationsByProfOfStudents","dashboardEvaluations","evaluationsByUser"],
    baseQuery: fakeBaseQuery(),
    endpoints: (builder) => ({
        addOrEditBulletin: builder.mutation({
            async queryFn({ id, ...data }) {
                try {
                    const user = auth.currentUser;
                    if (!user) {
                        return { error: { message: "Aucun utilisateur connecté." } };
                    }
                    const userId = user?.uid;
                    if (!id) {
                        const docRef = await addDoc(collection(db, "bulletins"), { 
                            ...data, 
                            createdAt: serverTimestamp(), 
                            createdBy: userId, 
                            updatedAt: serverTimestamp() });
                        return {
                            data: {
                                id: docRef.id,
                                message: "Bulletin enregistré !",
                                ...data,
                            },
                        };

                    } else {
                        // Mettre à jour Firestore
                        const docRef = doc(db, "bulletins", id);
                        await updateDoc(docRef, { ...data, updatedAt: serverTimestamp() });

                        return {
                            data: {
                                message:
                                    "Bulletin modifié !",
                            },
                        };
                    }
                } catch (error: any) {
                    return { error: { status: "CUSTOM", message: error.message } };
                }
            },
            invalidatesTags: ["evaluation", "evaluations",'evaluationsByStudent', 'evaluationsByProf', 'dashboardEvaluations',"evaluationsByProfOfStudents"],
        }),
        addOrEditEvaluation: builder.mutation({
            async queryFn({ id, ...data }) {
                try {
                    const user = auth.currentUser;
                    if (!user) {
                        return { error: { message: "Aucun utilisateur connecté." } };
                    }
                    const userId = user?.uid;
                    if (!id) {
                        const docRef = await addDoc(collection(db, "evaluations"), { ...data, createdAt: serverTimestamp(), createdBy: userId, updatedAt: serverTimestamp() });
                        return {
                            data: {
                                id: docRef.id,
                                message: "Évaluation enregistrée !",
                                ...data,
                            },
                        };

                    } else {
                        // Mettre à jour Firestore
                        const compRef = doc(db, "evaluations", id);
                        await updateDoc(compRef, { ...data, updatedAt: serverTimestamp() });

                        return {
                            data: {
                                message:
                                    "Évaluation modifiée !",
                            },
                        };
                    }
                } catch (error: any) {
                    return { error: { status: "CUSTOM", message: error.message } };
                }
            },
            invalidatesTags: ["evaluation", "evaluations",'evaluationsByStudent', 'evaluationsByProf', 'dashboardEvaluations',"evaluationsByProfOfStudents"],
        }),
        getEvaluations: builder.query({
            async queryFn() {
                try {
                    return new Promise((resolve) => {
                        const q = query(
                            collection(db, "evaluations"),
                            orderBy("createdAt", "desc"),
                        );
                        onSnapshot(q, (snapshot) => {
                            const Evaluations = snapshot.docs.map((doc) => ({
                                id: doc.id,
                                ...doc.data(),
                            }));
                            resolve({ data: Evaluations as Evaluation[] });
                        });
                        // unsubscribe();
                    });
                } catch (error) {
                    return { error };
                }
            },
            keepUnusedDataFor: 0,
            async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
                const evaluationsRef = query(
                    collection(db, "evaluations"),
                    orderBy("createdAt", "desc"),
                );
                let unsubscribe;
                try {
                    await cacheDataLoaded;

                    unsubscribe = onSnapshot(evaluationsRef, (snapshot) => {
                        const evaluations = snapshot.docs.map((doc) => ({
                            id: doc.id,
                            ...doc.data(),
                        }));
                        updateCachedData(() => evaluations as Evaluation[]);
                    });
                } catch (error) {
                    console.error("Erreur de souscription:", error);
                }

                // Nettoyer l'écouteur Firestore quand le cache est supprimé
                await cacheEntryRemoved;
                if (unsubscribe) unsubscribe();
            },
            providesTags: ["evaluations"],
        }),
        getEvaluationsByProf: builder.query({
            // queryFn simple, juste pour initialiser le cache
            async queryFn() {
                

                try {
                const user = auth.currentUser;
                
                
                if (!user) return { error: { message: "Aucun utilisateur connecté." } };


                    const q = query(
                        collection(db, "evaluations"),
                        where("createdBy", "==", user.uid),
                        orderBy("createdAt", "desc")
                    );

                    const snapshot = await getDocs(q); // ← getDocs, pas onSnapshot ici

                    const evaluations = snapshot.docs.map((doc) => ({
                        id: doc.id,
                        ...doc.data(),
                    })) as any[];

                    const evaluationsWithMatiere = await Promise.all(
                        evaluations.map(async (evaluation) => {
                            if (!evaluation.matiere) return evaluation;
                            try {
                                const matiereRef = doc(db, "matieres", evaluation.matiere);
                                const matiereSnap = await getDoc(matiereRef);
                                return {
                                    ...evaluation,
                                    matiereData: matiereSnap.exists()
                                        ? matiereSnap.data() 
                                        : evaluation.matiere,
                                };
                            } catch {
                                return evaluation;
                            }
                        })
                    );

                    const evaluationsWithMatiereAndCompetence = await Promise.all(
                        evaluationsWithMatiere.map(async (evaluation) => {
                            if (!evaluation.competence) return evaluation;
                            try {
                                const competenceRef = doc(db, "competences", evaluation.competence);
                                const competenceSnap = await getDoc(competenceRef);

                                const competenceStudentRef = doc(db, "competencesStudents", evaluation.competence);
                                const competenceStudentSnap = await getDoc(competenceStudentRef);
                                return {
                                    ...evaluation,
                                    competenceData: competenceSnap.exists()
                                        ? competenceSnap.data() 
                                        : evaluation.competence,
                                    competenceStudentData: competenceStudentSnap.exists()
                                        ? competenceStudentSnap.data()
                                        : evaluation.competence,
                                };
                            } catch {
                                return evaluation;
                            }
                        })
                    );

                    const evaluationsWithMatiereAndCompetenceAndStudent = await Promise.all(
                        evaluationsWithMatiereAndCompetence.map(async (evaluation) => {
                            if (!evaluation.student) return evaluation;
                            try {
                                const studentRef = doc(db, "users", evaluation.student);
                                const studentSnap = await getDoc(studentRef);
                                return {
                                    ...evaluation,
                                    studentData: studentSnap.exists()
                                        ? studentSnap.data() 
                                        : evaluation.student,
                                };
                            } catch {
                                return evaluation;
                            }
                        })
                        
                    );

                    return { data: evaluationsWithMatiereAndCompetenceAndStudent };
                } catch (error) {
                    console.error("ERREUR queryFn:", error);
                    return { error };
                }
            },

            keepUnusedDataFor: 60, // ← pas 0, laisse le temps à onCacheEntryAdded

            async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
                let unsubscribe: (() => void) | undefined;

                try {
                    await cacheDataLoaded; // attend que queryFn ait résolu

                    const user = auth.currentUser;
                    if (!user) return;

                    const q = query(
                        collection(db, "evaluations"),
                        where("createdBy", "==", user.uid),
                        orderBy("createdAt", "desc")
                    );

                    unsubscribe = onSnapshot(q, async (snapshot) => {
                        const evaluations = snapshot.docs.map((d) => ({
                            id: d.id,
                            ...d.data(),
                        })) as any[];

                        const evaluationsWithMatiere = await Promise.all(
                            evaluations.map(async (evaluation) => {
                                if (!evaluation.matiere) return evaluation;
                                try {
                                    const matiereRef = doc(db, "matieres", evaluation.matiere);
                                    const matiereSnap = await getDoc(matiereRef);
                                    return {
                                        ...evaluation,
                                        matiereData: matiereSnap.exists()
                                            ? matiereSnap.data() 
                                            : evaluation.matiere,
                                    };
                                } catch {
                                    return evaluation;
                                }
                            })
                        );

                        const evaluationsWithMatiereAndCompetence = await Promise.all(
                            evaluationsWithMatiere.map(async (evaluation) => {
                                if (!evaluation.competence) return evaluation;
                                try {
                                    const competenceRef = doc(db, "competences", evaluation.competence);
                                    const competenceSnap = await getDoc(competenceRef);

                                    const competenceStudentRef = doc(db, "competencesStudents", evaluation.competence);
                                    const competenceStudentSnap = await getDoc(competenceStudentRef);
                                
                                    return {
                                        ...evaluation,
                                        competenceData: competenceSnap.exists()
                                            ? competenceSnap.data() 
                                            : evaluation.competence,
                                        competenceStudentData: competenceStudentSnap.exists()
                                            ? competenceStudentSnap.data()
                                            : evaluation.competence,
                                    };
                                } catch {
                                    return evaluation;
                                }
                            })
                        );

                        const evaluationsWithMatiereAndCompetenceAndStudent = await Promise.all(
                            evaluationsWithMatiereAndCompetence.map(async (evaluation) => {
                                
                                try {
                                    const studentSnap = await getDoc(doc(db, "users", evaluation.student));
                                    if (!studentSnap.exists()) return evaluation;
                                    
                                    const studentData = studentSnap.data();

                                    // Récupérer la classe du student
                                    let classeData = null;
                                    if (studentData?.classe) {
                                        try {
                                            const classeSnap = await getDoc(doc(db, "classrooms", studentData.classe));
                                            classeData = classeSnap.exists() ? classeSnap.data() : null;
                                        } catch { }
                                    }

                                    return {
                                        ...evaluation,
                                        studentData: {
                                            ...studentData,
                                            classeData, 
                                        },
                                    };
                                } catch { return evaluation; }
                            })
                        );

                        updateCachedData(() => evaluationsWithMatiereAndCompetenceAndStudent);
                    });

                } catch {
                    // cacheDataLoaded rejeté → silencieux
                }

                await cacheEntryRemoved;
                if (unsubscribe) unsubscribe(); // nettoyage du listener
            },

            providesTags: ["evaluationsByProf"],
        }),
        getEvaluationsByProfOfStudents: builder.query({
            async queryFn() {
                try {
                    const user = auth.currentUser;
                    if (!user) return { error: { message: "Aucun utilisateur connecté." } };

                    const q = query(
                        collection(db, "evaluations"),
                        where("createdBy", "==", user.uid),
                        orderBy("createdAt", "desc")
                    );

                    const snapshot = await getDocs(q);
                    const evaluations = snapshot.docs.map((doc) => ({
                        uid: doc.id,
                        ...doc.data(),
                    })) as any[];

                    const enrichedEvaluations = await enrichEvaluations(evaluations);
                    const groupedByStudent = await groupAndCalculate(enrichedEvaluations);

                    return { data: groupedByStudent };
                } catch (error) {
                    console.error("ERREUR queryFn:", error);
                    return { error };
                }
            },

            keepUnusedDataFor: 60,

            async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
                let unsubscribe: (() => void) | undefined;

                try {
                    await cacheDataLoaded;

                    const user = auth.currentUser;
                    if (!user) return;

                    const q = query(
                        collection(db, "evaluations"),
                        where("createdBy", "==", user.uid),
                        orderBy("createdAt", "desc")
                    );

                    unsubscribe = onSnapshot(q, async (snapshot) => {
                        const evaluations = snapshot.docs.map((d) => ({
                            uid: d.id,
                            ...d.data(),
                        })) as any[];

                        const enrichedEvaluations = await enrichEvaluations(evaluations);
                        const groupedByStudent = await groupAndCalculate(enrichedEvaluations);

                        updateCachedData(() => groupedByStudent);
                    });

                } catch {
                    // silencieux
                }

                await cacheEntryRemoved;
                if (unsubscribe) unsubscribe();
            },

            providesTags: ["evaluationsByProfOfStudents"],
        }),
        getEvaluationById: builder.query({
            queryFn: async (EvaluationId) => {
                try {
                    const EvaluationRef = doc(db, "evaluations", EvaluationId);
                    const EvaluationSnap = await getDoc(EvaluationRef);

                    if (!EvaluationSnap.exists()) {
                        return {
                            error: { status: 404, message: "Évaluation introuvable !" },
                        };
                    }

                    return { data: { id: EvaluationSnap.id, ...EvaluationSnap.data() } };
                } catch (error: any) {
                    return { error: { status: 500, message: error.message } };
                }
            },
            providesTags: ["evaluation"],
        }),
        getEvaluationsByStudent: builder.query({
            
            async queryFn(studentId: string) {
                
                if (!studentId) return { error: { message: "studentId manquant" } };

                try {
                const user = auth.currentUser;
                
                
                if (!user) return { error: { message: "Aucun utilisateur connecté." } };

                const q = query(
                    collection(db, "evaluations"),
                    where("createdBy", "==", user.uid),
                    where("student", "==", studentId),
                    orderBy("createdAt", "desc")
                );


                const snapshot = await getDocs(q); // ← getDocs, pas onSnapshot ici


                const evaluations = snapshot.docs.map((doc) => ({
                    uid: doc.id,
                    ...doc.data(),
                })) as any[];


                const evaluationsWithMatiere = await Promise.all(
                    evaluations.map(async (evaluation) => {
                    if (!evaluation.matiere) return evaluation;
                    try {
                        const matiereRef = doc(db, "matieres", evaluation.matiere);
                        const matiereSnap = await getDoc(matiereRef);
                        return {
                        ...evaluation,
                        matiere: matiereSnap.exists()
                            ? { uid: matiereSnap.id, ...matiereSnap.data() }
                            : evaluation.matiere,
                        };
                    } catch {
                        return evaluation;
                    }
                    })
                );

                return { data: evaluationsWithMatiere };
                } catch (error) {
                    console.error("ERREUR queryFn:", error);
                    return { error };
                }
            },

            keepUnusedDataFor: 60, // ← pas 0, laisse le temps à onCacheEntryAdded

            async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
                let unsubscribe: (() => void) | undefined;

                try {
                await cacheDataLoaded; // attend que queryFn ait résolu

                const user = auth.currentUser;
                if (!user) return;

                const q = query(
                    collection(db, "evaluations"),
                    where("createdBy", "==", user.uid),
                    where("student", "==", arg),
                    orderBy("createdAt", "desc")
                );

                unsubscribe = onSnapshot(q, async (snapshot) => {
                    const evaluations = snapshot.docs.map((d) => ({
                    uid: d.id,
                    ...d.data(),
                    })) as any[];

                    const evaluationsWithMatiere = await Promise.all(
                    evaluations.map(async (evaluation) => {
                        if (!evaluation.matiere) return evaluation;
                        try {
                        const matiereRef = doc(db, "matieres", evaluation.matiere);
                        const matiereSnap = await getDoc(matiereRef);
                        return {
                            ...evaluation,
                            matiere: matiereSnap.exists()
                            ? { uid: matiereSnap.id, ...matiereSnap.data() }
                            : evaluation.matiere,
                        };
                        } catch {
                        return evaluation;
                        }
                    })
                    );

                    updateCachedData(() => evaluationsWithMatiere);
                });

                } catch {
                // cacheDataLoaded rejeté → silencieux
                }

                await cacheEntryRemoved;
                if (unsubscribe) unsubscribe(); // nettoyage du listener
            },

            providesTags: ["evaluationsByStudent"],
        }),
        // Supprimer
        deleteEvaluation: builder.mutation({
            queryFn: async (uid) => {
                try {
                    const docRef = doc(db, "evaluations", uid);
                    await deleteDoc(docRef);
                    return {
                        data: { uid, message: "Évaluation supprimée !", success: true },
                    };
                } catch (error: any) {
                    return { error: { status: "DELETE_ERROR", message: error.message } };
                }
            },
            invalidatesTags: ["evaluation", "evaluations","dashboardEvaluations"],
        }),

        //get data for dashboard evaluations
        getDashboardEvalsByProf: builder.query<DashboardStats, void>({
            async queryFn() {
                try {
                const user = auth.currentUser;
                if (!user) {
                    return { error: { status: "CUSTOM_ERROR", error: "Aucun utilisateur connecté." } };
                }

                // 1. Récupérer les classes du prof
                const classesSnap = await getDocs(
                    query(
                    collection(db, "classrooms"),
                    where("createdBy", "==", user.uid),
                    orderBy("createdAt", "desc")
                    )
                );
                const classes = classesSnap.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                })) as Class[];

                const allStudentIds = classes.flatMap((c) => c.students || []);
                const uniqueStudentIds = Array.from(new Set(allStudentIds));

                // 2. Récupérer les évaluations du prof
                const now = new Date();
                const startOfMonth = new Timestamp(
                    Math.floor(new Date(now.getFullYear(), now.getMonth(), 1).getTime() / 1000),
                    0
                );

                const evaluationsSnap = await getDocs(
                    query(
                    collection(db, "evaluations"),
                    where("createdBy", "==", user.uid)
                    )
                );
                const evaluations = evaluationsSnap.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                })) as Evaluation[];

                const evaluationsThisMonth = evaluations.filter(
                    (e) => e.createdAt?.seconds >= startOfMonth.seconds
                ).length;

                // 3. Récupérer les objectifsStudent du prof
                    // const objectifsSnap = await getDocs(
                    //     query(
                    //     collection(db, "objectifStudents"),
                    //     where("createdBy", "==", user.uid)
                    //     )
                    // );
                    // const objectifStudents = objectifsSnap.docs.map((doc) => ({
                    //     id: doc.id,
                    //     ...doc.data(),
                    // })) as ObjectifStudent[];

                // 4. Calculer les stats par classe
                const classeStats: ClassStats[] = classes.map((classe) => {
                    const studentIds = classe.students || [];

                    // Évaluations des élèves de cette classe
                    const classeEvals = evaluations.filter((e) => {
                    const studentId = e.student;
                    return studentIds.includes(studentId);
                    });

                    const moyenne =
                        classeEvals.length > 0
                            ? classeEvals.reduce((sum, e) => sum + (Number(e.note) || 0), 0) / classeEvals.length
                            : 0;

                    // Objectifs terminés / total pour les élèves de cette classe
                        // const classeObjectifs = objectifStudents.filter((o) =>
                        //         studentIds.includes(o.studentId)
                        // );

                        // const objectifsPercent =
                        // classeObjectifs.length > 0
                        //     ? Math.round(
                        //         (classeObjectifs.filter((o) => o.status === "Terminé").length /
                        //         classeObjectifs.length) *
                        //         100
                        //     )
                        //     : 0;

                    return {
                    id: classe.id,
                    name: classe.name,
                    studentsCount: studentIds.length,
                    evaluationCount: classeEvals.length,
                    moyenne: Math.round(moyenne * 10) / 10, // arrondi 1 décimale
                    // objectifsPercent,
                    };
                });

                // 5. Moyenne générale (toutes classes confondues)
                const moyenneGenerale =
                    evaluations.length > 0
                        ? Math.round(
                            (evaluations.reduce((sum, e) => sum + (Number(e.note) || 0), 0) /
                                evaluations.length) *
                                10
                            ) / 10
                        : 0;

                return {
                    data: {
                    activeStudents: uniqueStudentIds.length,
                    evaluationsThisMonth,
                    moyenneGenerale,
                    classeStats,
                    },
                };
                } catch (error) {
                return { error: { status: "CUSTOM_ERROR", error: String(error) } };
                }
            },

            keepUnusedDataFor: 0,

            async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
                const user = auth.currentUser;
                if (!user) return;

                // Écoute les changements sur les classes du prof
                const classesRef = query(
                collection(db, "classrooms"),
                where("createdBy", "==", user.uid)
                );

                const evaluationsRef = query(
                    collection(db, "evaluations"),
                    where("createdBy", "==", user.uid)
                );

                let unsubscribeClasses: (() => void) | undefined;
                let unsubscribeEvaluations: (() => void) | undefined;

                try {
                await cacheDataLoaded;

                const refreshDashboard = async () => {
                    // Re-fetch toutes les données à chaque changement
                    try {
                    const classesSnap = await getDocs(classesRef);
                    const classes = classesSnap.docs.map((doc) => ({
                        id: doc.id,
                        ...doc.data(),
                    })) as Class[];

                    const allStudentIds = classes.flatMap((c) => c.students || []);
                    const uniqueStudentIds = Array.from(new Set(allStudentIds));

                    const now = new Date();
                    const startOfMonth = new Timestamp(
                        Math.floor(new Date(now.getFullYear(), now.getMonth(), 1).getTime() / 1000),
                        0
                    );

                    const [evaluationsSnap, objectifsSnap] = await Promise.all([
                        getDocs(query(collection(db, "evaluations"), where("createdBy", "==", user.uid))),
                        // getDocs(query(collection(db, "objectifStudents"), where("createdBy", "==", user.uid))),
                        { data: [] } as any, // Placeholder pour les objectifs
                    ]);

                    const evaluations = evaluationsSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() })) as Evaluation[];
                    //const objectifStudents = objectifsSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() })) as ObjectifStudent[];

                    const evaluationsThisMonth = evaluations.filter(
                        (e) => e.createdAt?.seconds >= startOfMonth.seconds
                    ).length;

                    const classeStats: ClassStats[] = classes.map((classe) => {
                        const studentIds = classe.students || [];

                        const classeEvals = evaluations.filter((e) => {
                        const studentId = e.student;
                        return studentIds.includes(studentId);
                        });

                        const moyenne =
                            classeEvals.length > 0
                                ? classeEvals.reduce((sum, e) => sum + (Number(e.note) || 0), 0) / classeEvals.length
                                : 0;

                        // const classeObjectifs = objectifStudents.filter((o) =>
                        // studentIds.includes(o.studentId)
                        // );

                        // const objectifsPercent =
                        // classeObjectifs.length > 0
                        //     ? Math.round(
                        //         (classeObjectifs.filter((o) => o.status === "Terminé").length /
                        //         classeObjectifs.length) *
                        //         100
                        //     )
                        //     : 0;

                        return {
                        id: classe.id,
                        name: classe.name,
                        studentsCount: studentIds.length,
                        evaluationCount: classeEvals.length,
                        moyenne: Math.round(moyenne * 10) / 10,
                        // objectifsPercent,
                        };
                    });

                    const moyenneGenerale =
                        evaluations.length > 0
                            ? Math.round(
                                (evaluations.reduce((sum, e) => sum + (Number(e.note) || 0), 0) /
                                    evaluations.length) *
                                    10
                                ) / 10
                            : 0;

                    updateCachedData(() => ({
                        activeStudents: uniqueStudentIds.length,
                        evaluationsThisMonth,
                        moyenneGenerale,
                        classeStats,
                    }));
                    } catch (err) {
                    console.error("Erreur mise à jour dashboard:", err);
                    }
                };

                unsubscribeClasses = onSnapshot(classesRef, refreshDashboard);
                unsubscribeEvaluations = onSnapshot(evaluationsRef, refreshDashboard);
                } catch {
                return;
                }

                await cacheEntryRemoved;
                unsubscribeClasses?.();
                unsubscribeEvaluations?.();
            },

            providesTags: ["dashboardEvaluations"],
        }),
        getEvaluationsByUser: builder.query({
            async queryFn(studentId: string) {

                try {
                // const user = auth.currentUser;
                // if (!user) return { error: { message: "Aucun utilisateur connecté." } };

                const q = query(
                    collection(db, "evaluations"),
                    where("student", "==", studentId),
                    orderBy("createdAt", "desc")
                );

                const snapshot = await getDocs(q); // ← getDocs, pas onSnapshot ici

                const evaluations = snapshot.docs.map((doc) => ({
                    uid: doc.id,
                    ...doc.data(),
                })) as any[];

                const enriched = await enrichEvaluations(evaluations);
                const { byMatiere, moyenneGenerale } = groupByMatiereWithMoyenne(enriched);

                return { data: { evaluations: enriched, byMatiere, moyenneGenerale } };
                } catch (error) {
                console.error("ERREUR queryFn:", error);
                return { error };
                }
            },

            keepUnusedDataFor: 60, // ← pas 0, laisse le temps à onCacheEntryAdded

            async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
                let unsubscribe: (() => void) | undefined;

                try {
                await cacheDataLoaded; // attend que queryFn ait résolu

                // const user = auth.currentUser;
                // if (!user) return;

                const q = query(
                    collection(db, "evaluations"),
                    where("student", "==", arg),
                    orderBy("createdAt", "desc")
                );

                unsubscribe = onSnapshot(q, async (snapshot) => {
                    const evaluations = snapshot.docs.map((d) => ({
                    uid: d.id,
                    ...d.data(),
                    })) as any[];

                    const enriched = await enrichEvaluations(evaluations);
                    const { byMatiere, moyenneGenerale } = groupByMatiereWithMoyenne(enriched);

                    updateCachedData(() => ({
                    evaluations: enriched,
                    byMatiere,
                    moyenneGenerale,
                    }));
                });
                } catch {
                // cacheDataLoaded rejeté → silencieux
                }

                await cacheEntryRemoved;
                if (unsubscribe) unsubscribe(); // nettoyage du listener
            },

            providesTags: ["evaluationsByUser"],
        }),
    }),
});

export const {
    useAddOrEditEvaluationMutation,
    useGetEvaluationsQuery,
    useDeleteEvaluationMutation,
    useLazyGetEvaluationByIdQuery,
    useGetEvaluationsByStudentQuery,
    useGetEvaluationsByProfQuery,
    useGetEvaluationsByProfOfStudentsQuery,
    useGetDashboardEvalsByProfQuery,
    useAddOrEditBulletinMutation,
    useGetEvaluationsByUserQuery
} = EvaluationApi;

export function useEvaluationFromLocation(): [
    Evaluation,
    boolean,
    string,
    (id: string) => any
] {
    const itemState = useLocationState<Evaluation | undefined>(undefined);
    const [item, setItem] = useState(itemState);
    const { id } = useParams<{ id: string }>();
    const [findById, { data, isError, isLoading }] = useLazyGetEvaluationByIdQuery();
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            findById(id as string);
        }
    }, [id]);
    useEffect(() => {
        if (isError && !itemState) {
            navigate(-1);
        }
    }, [isError]);
    useEffect(() => {
        if (data) {
            setItem(data as Evaluation);
        }
    }, [data]);

    return [item as Evaluation & { bio: string }, isLoading, id as string, findById];
}

// Enrichir les évaluations avec matiere, competence, student
export const enrichEvaluations = async (evaluations: any[]) => {
    const withMatiere = await Promise.all(
        evaluations.map(async (evaluation) => {
            if (!evaluation.matiere) return evaluation;
            try {
                const matiereSnap = await getDoc(doc(db, "matieres", evaluation.matiere));
                return {
                    ...evaluation,
                    matiereData: matiereSnap.exists() ? matiereSnap.data() : evaluation.matiere,
                };
            } catch { return evaluation; }
        })
    );

    const withCompetence = await Promise.all(
        withMatiere.map(async (evaluation) => {
            if (!evaluation.competence) return evaluation;
            try {
                const competenceSnap = await getDoc(doc(db, "competences", evaluation.competence));
                const competenceStudentSnap = await getDoc(doc(db, "competencesStudents", evaluation.competence));
                
                return {
                    ...evaluation,
                    competenceData: competenceSnap.exists() ? competenceSnap.data() : evaluation.competence,
                    competenceStudentData: competenceStudentSnap.exists() ? competenceStudentSnap.data() : evaluation.competence,
                };
            } catch { return evaluation; }
        })
    );

    const withStudent = await Promise.all(
        withCompetence.map(async (evaluation) => {
            if (!evaluation.student) return evaluation;
            try {
                const studentSnap = await getDoc(doc(db, "users", evaluation.student));
                if (!studentSnap.exists()) return evaluation;
                
                const studentData = studentSnap.data();

                // Récupérer la classe du student
                let classeData = null;
                if (studentData?.classe) {
                    try {
                        const classeSnap = await getDoc(doc(db, "classrooms", studentData.classe));
                        classeData = classeSnap.exists() ? classeSnap.data() : null;
                    } catch { }
                }

                return {
                    ...evaluation,
                    studentData: {
                        ...studentData,
                        classeData, 
                    },
                };
            } catch { return evaluation; }
        })
    );
                
    return withStudent;
};

// Grouper par student + calculer moyenne et nombre de notes
const groupAndCalculate = async (evaluations: any[]) => {
    // 1. Grouper les évaluations et accumuler les totaux
    const groups: Record<string, StudentGroup> = evaluations.reduce((acc, evaluation) => {
        const studentId = evaluation.student;
        if (!studentId) return acc;

        if (!acc[studentId]) {
            acc[studentId] = {
                studentData: { ...evaluation.studentData }, // éviter la mutation de référence partagée
                bulletinData: null,
                evaluations: [],
                moyenne: 0,
                nombreNotes: 0,
                totalNotes: 0,
            };
        }

        const group = acc[studentId];
        group.evaluations.push(evaluation);

        const note = parseFloat(evaluation.note);
        if (!isNaN(note)) {
            group.totalNotes += note;
            group.nombreNotes += 1;
        }

        return acc;
    }, {} as Record<string, StudentGroup>);

    // 2. Calculer la moyenne de façon synchrone — pas besoin d'attendre l'async
    for (const group of Object.values(groups)) {
        group.moyenne =
            group.nombreNotes > 0
                ? Number((group.totalNotes / group.nombreNotes).toFixed(2))
                : 0;
    }

    // 3. Récupérer les données externes par étudiant en parallèle
    await Promise.all(
        Object.entries(groups).map(async ([studentId, group]) => {
            try {
                // Récupérer le bulletin , les objectifs , les absences en parallèle
                const [bulletinsSnap, absencesSnap] = await Promise.all([
                    getDocs(query(
                        collection(db, "bulletins"),
                        where("userId", "==", studentId),
                        orderBy("createdAt", "desc"),
                        limit(1)
                    )),
                    // getDocs(query(
                    //     collection(db, "objectifStudents"),
                    //     where("studentId", "==", studentId)
                    // )),
                    getDocs(query(
                        collection(db, "absences"),
                        where("student.uid", "==", studentId) 
                    )),
                ]);

                // Bulletin
                if (!bulletinsSnap.empty) {
                    const docSnap = bulletinsSnap.docs[0];
                    group.bulletinData = { id: docSnap.id, ...docSnap.data() } as Bulletin;
                }

                //objectifs
                // if(!allObjectifsSnap.empty) {
                //     group.objectifs = allObjectifsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })) as ObjectifStudent[];
                // }

                //absences
                if(!absencesSnap.empty) {
                    group.absences = absencesSnap.docs.map(doc => ({ uid: doc.id, ...doc.data() })) as Absence[];
                }



                // Objectifs — une seule requête, deux comptages
                // const totalObjectifs = allObjectifsSnap.size;
                // const objectifsTermines = allObjectifsSnap.docs.filter(
                //     (doc) => doc.data().status === "Terminé"
                // ).length;

                // group.objectifsTermines = objectifsTermines;
                // group.totalObjectifs = totalObjectifs;

                group.studentData = {
                    ...group.studentData
                };

            } catch (error) {
                console.error(`Erreur récupération données étudiant ${studentId}:`, error);
            }
        })
    );

    // 4. Supprimer les champs accumulateurs internes avant de retourner
    return Object.values(groups).map(({ totalNotes, ...group }) => group);
};

// Groupe les évaluations par matière et calcule les moyennes
const groupByMatiereWithMoyenne = (evaluations: any[]) => {
  const groups = new Map<string, { matiere: any; evaluations: any[] }>();

  for (const evaluation of evaluations) {
    const matiereId = evaluation.matiere; // id brut (string)
    const matiereData = evaluation.matiereData;
    const key = matiereId ?? "sans-matiere";

    if (!groups.has(key)) {
      groups.set(key, { matiere: matiereData, evaluations: [] });
    }
    groups.get(key)!.evaluations.push(evaluation);
  }

  const byMatiere = Array.from(groups.entries()).map(([matiereId, group]) => {
    const notesValides = group.evaluations
      .map((e) => Number(e.note))
      .filter((n) => !isNaN(n));

    const moyenne =
      notesValides.length > 0
        ? notesValides.reduce((sum, n) => sum + n, 0) / notesValides.length
        : null;

    return {
      matiereId,
      matiere: group.matiere,
      evaluations: group.evaluations,
      moyenne,
    };
  });

  const toutesLesNotes = evaluations
    .map((e) => Number(e.note))
    .filter((n) => !isNaN(n));

  const moyenneGenerale =
    toutesLesNotes.length > 0
      ? toutesLesNotes.reduce((sum, n) => sum + n, 0) / toutesLesNotes.length
      : null;

  return { byMatiere, moyenneGenerale };
};
